<span [ngSwitch]="status.statusCode">
  <span class="badge-status grey" *ngSwitchCase="evaluationTaskStatus.New">
    {{status.title}}
  </span>
  <span class="badge-status success-with-border" *ngSwitchCase="evaluationTaskStatus.Active">
    {{status.title}}
  </span>
  <span class="badge-status orange_ff" *ngSwitchCase="evaluationTaskStatus.Waiting_First_Review">
    {{status.title}}
  </span>
  <span class="badge-status purple" *ngSwitchCase="evaluationTaskStatus.Modifications_Requested_From_First_Review">
    {{status.title}}
  </span>
  <span class="badge-status orange_ff" *ngSwitchCase="evaluationTaskStatus.Waiting_Final_Review">
    {{status.title}}
  </span>
  <span class="badge-status purple" *ngSwitchCase="evaluationTaskStatus.Modifications_Requested_From_Final_Review">
    {{status.title}}
  </span>
  <span class="badge-status orange_ff" *ngSwitchCase="evaluationTaskStatus.Waiting_Final_Approval">
    {{status.title}}
  </span>
  <span class="badge-status success-with-border" *ngSwitchCase="evaluationTaskStatus.Final_Report_Approved">
    {{status.title}}
  </span>
  <span class="badge-status red_2" *ngSwitchCase="evaluationTaskStatus.Final_Report_Rejected">
    {{status.title}}
  </span>
  <span class="badge-status danger-with-border" *ngSwitchCase="evaluationTaskStatus.Overdue">
    {{status.title}}
  </span>
  <span class="badge-status success-with-border" *ngSwitchCase="evaluationTaskStatus.Send_Report_to_Operator">
    {{status.title}}
  </span>
</span>